import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/* any functionality that's shared between component variants but not needed by external components goes in this file */
import React, { useState, useRef, useEffect } from 'react';
import { isKeyboardEvent, tabbingOutsideOfElement } from '@chegg-ui/utils';
export function useToggletipBehavior(targetElement) {
  var wrapperRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isToggletipShown = _useState2[0],
      setIsToggletipShown = _useState2[1]; // event can either be a React synthetic event (from user interaction) or a "real" event (from the onclick listeners)


  var hideToggletip = function hideToggletip(e) {
    if (isKeyboardEvent(e)) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        setIsToggletipShown(false);
      }

      if (wrapperRef.current && tabbingOutsideOfElement(e, wrapperRef.current)) {
        setIsToggletipShown(false);
      }
    } else {
      setIsToggletipShown(false);
    }
  };

  var showToggletip = function showToggletip() {
    if (isToggletipShown) {
      // we set a timeout to make sure the content goes away and comes back (for live region behavior)
      setTimeout(function () {
        setIsToggletipShown(true);
      }, 0);
    } else {
      setIsToggletipShown(true);
    }
  };

  useEffect(function () {
    if (isToggletipShown) {
      // use capture instead of bubble here to prevent race condition leading to unintentional closing
      document.addEventListener('click', hideToggletip, true);
      document.addEventListener('keydown', hideToggletip, true);
    }

    return function () {
      document.removeEventListener('click', hideToggletip, true);
      document.removeEventListener('keydown', hideToggletip, true);
    };
  }, [isToggletipShown]);
  var givenOnClick = targetElement.props.onClick;
  var givenOnKeyDown = targetElement.props.onKeyDown;
  var extendedTargetElement = /*#__PURE__*/React.cloneElement(targetElement, _defineProperty({
    onClick: function onClick(e) {
      if (givenOnClick) {
        givenOnClick(e);
      }

      showToggletip();
    },
    onKeyDown: function onKeyDown(e) {
      if (givenOnKeyDown) {
        givenOnKeyDown(e);
      }

      if (e.key && e.key === 'Enter') {
        showToggletip();
      }
    }
  }, 'aria-expanded', isToggletipShown));
  return {
    isToggletipShown: isToggletipShown,
    extendedTargetElement: extendedTargetElement,
    wrapperRef: wrapperRef
  };
}